
        <button type="button" class="modal-close__btn">
            <img class="modal-close__icon" src="{{modalCloseSvg}}" alt="close__icon" />
        </button>
            <div class="modal-circle__img-container">
                <img src="{{modalImg}}" alt="circle__img" class="modal-circle__img" />
            </div>
            <div class="modal-innner-container">
                <div class="modal__img-container">
                    <img src="{{modalImg}}" alt="modal__img" class="modal__img" />
                </div>
                <ul class="modal-list">
                    <li class="modal-list__item">
                        <h5 class="modal-list__subtitle">info</h5>
                        <p class="modal-list__text">
                            {{modalInfo}}
                        </p>
                    </li>
                    <li class="modal-list__item">
                        <h5 class="modal-list__subtitle">when</h5>
                        <p class="modal-list__text modal-list__text--margin">{{modalDate}}</p>
                        <p class="modal-list__text">{{modalTime}}</p>
                    </li>
                    <li class="modal-list__item">
                        <h5 class="modal-list__subtitle">where</h5>
                        <p class="modal-list__text modal-list__text--margin">{{modalCity}}</p>
                        <p class="modal-list__text">{{modalPlace}}</p>
                    </li>
                    <li class="modal-list__item">
                        <h5 class="modal-list__subtitle">who</h5>
                        <p class="modal-list__text">{{modalAuthor}}</p>
                    </li>
                    <li class="modal-list__item">
                        <h5 class="modal-list__subtitle modal-list__subtitle--margin">prices</h5>
                        <div class="modal-price-container">
                            <img class="modal-barcode__icon" src="{{modalBarcodeSvg}}" alt="barcode" />
                            <p class="modal-list__text modal-list__text--uppercase">{{modalPrice}}</p>
                        </div>
                        <a class="modal-list__link-buy" href="{{moreFromAuthor}}">Buy Tickets</a>
                    </li>
                </ul>
            </div>
            <a class="modal__link-autor" href="{{moreFromAuthor}}" target="_blank">More from this author</a>